import React from 'react'
import Button from '@material-ui/core/Button'

const variantStyles = {
  primary: {
    background: 'var(--df-primary)',
    color: '#fbf8f1',
    border: '1px solid var(--df-primary-2)',
    boxShadow: '0 4px 14px rgba(31,94,58,.20)',
  },
  ghost: {
    background: 'transparent',
    color: 'var(--df-ink-2)',
    border: '1px solid transparent',
    boxShadow: 'none',
  },
  accent: {
    background: 'var(--df-accent)',
    color: '#fff',
    border: '1px solid var(--df-accent-2)',
    boxShadow: '0 4px 14px rgba(198,106,69,.25)',
  },
  danger: {
    background: 'var(--disposal, #a9341d)',
    color: '#fff',
    border: '1px solid #8b2917',
    boxShadow: 'none',
  },
}

const sizeStyles = {
  sm: { padding: '6px 10px', fontSize: 12, borderRadius: 8 },
  md: { padding: '9px 14px', fontSize: 13, borderRadius: 'var(--df-radius, 10px)' },
}

export default function DFButton({ variant = 'primary', size = 'md', children, style, ...rest }) {
  const vs = variantStyles[variant] || variantStyles.primary
  const ss = sizeStyles[size] || sizeStyles.md

  return (
    <Button
      {...rest}
      style={{
        textTransform: 'none',
        fontWeight: 600,
        fontFamily: 'inherit',
        lineHeight: 1.4,
        transition: 'background .12s, border-color .12s, transform .12s',
        ...vs,
        ...ss,
        ...style,
      }}
    >
      {children}
    </Button>
  )
}
